export const ADD_SUCCESS = 'Новый пользователь добавлен';
export const ADD_ERROR = 'Не удалось добавить нового пользователя';
